<template>
    <div v-html="require(`!html-loader!@/assets/img/${icon}.svg`)"></div>
</template>

<script>
import $ from "jquery";

export default {
    name: "svg-icon",

    props: {
        icon: {
            type: String,
            required: true
        },

        fill: {
            type: String
        }
    },

    mounted() {
        if (this.fill) {
            this.setFill();

            $(this.$el)
                .find("style")
                .remove();
        }
    },

    methods: {
        setFill() {
            this.$el.firstChild.setAttribute("fill", this.fill);
        }
    }
};
</script>
